import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { StateBanner } from '@kerfjs/ui/state-banner';
import type { SafeHtml } from 'kerfjs';
import { Eye } from 'lucide';

import type { Me } from '../../../data/api.js';

/**
 * The full-width strip above every view while a platform operator is acting as
 * this member (HS2-RHZ75A): who is being viewed, that it is read-only, and Stop,
 * which restores the operator's own session and returns to the console.
 */
export function ActingAsBanner({ viewer }: { viewer: Me | null }): SafeHtml | null {
  const current = viewer;
  if (current?.actingAs === null || current?.actingAs === undefined) return null;
  const who =
    current.name === null || current.name === undefined ? current.email : `${current.name} (${current.email})`;
  return (
    <StateBanner
      tone="warning"
      presentation="strip"
      urgency="alert"
      className="acting-as-banner"
      icon={<LucideIcon icon={Eye} name="" />}
      title={`Viewing as ${who}`}
      detail={`Read-only. Signed in as ${current.actingAs.operatorEmail}.`}
      action={
        <Button emphasis="secondary" size="compact" tone="neutral" action="stop-acting">
          Stop
        </Button>
      }
    />
  );
}
